import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const viewCartData = createAsyncThunk(
  "cartData/viewCartData",
  async (_, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.get(endPoint.VIEWCART, {
        headers: {
          sessionId: storedUuid ? storedUuid : "",
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteCartItem = createAsyncThunk(
  "cartData/deleteCartItem",
  async (productId, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.delete(endPoint.REMOVECART, {
        data: { productId: productId },
        headers: {
          sessionId: storedUuid ? storedUuid : "",
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      await thunkAPI.dispatch(viewCartData());
      return { productId };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ViewDataSlice = createSlice({
  name: "ViewCart",
  initialState: {
    ViewCart: [],
    error: null,
  },
  reducers: {
    incrementQuantity: (state, action) => {
      const itemPresent = state.cart.find(
        (item) => item._id === action.payload._id
      );
      itemPresent.quantity++;
    },
    decrementQuantity: (state, action) => {
      const itemPresent = state.cart.find(
        (item) => item._id === action.payload._id
      );
      if (itemPresent.quantity === 1) {
        itemPresent.quantity = 0;
        const removeItem = state.cart.filter(
          (item) => item._id !== action.payload._id
        );
        state.cart = removeItem;
      } else {
        itemPresent.quantity--;
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewCartData.fulfilled, (state, action) => {
        state.ViewCart = action.payload;
      })
      .addCase(viewCartData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  incrementQuantity,
  decrementQuantity,
  loginSuccess,
  loginFailure,
  logout,
  setData,
} = ViewDataSlice.actions;

export default ViewDataSlice.reducer;
